export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <img
              src="https://static.readdy.ai/image/e4140a6110134fefa958645e77b5a66a/cc1f1316833ca510742f9737478242fc.png"
              alt="Gleimatus Empreendimentos"
              className="h-20 w-auto mb-6"
            />
            <p className="text-gray-400 mb-6 leading-relaxed">
              Estruturando o presente, valorizando o futuro.
            </p>
            <p className="text-gray-400 text-sm leading-relaxed">
              Gleimatus Empreendimentos Ltda<br />
              CNPJ: 38.326.916/0001-09<br />
              Carandaí, Minas Gerais
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6">Links Rápidos</h4>
            <ul className="space-y-3">
              <li>
                <a href="#sobre" className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">
                  Sobre Nós
                </a>
              </li>
              <li>
                <a href="#valores" className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">
                  Valores
                </a>
              </li>
              <li>
                <a href="#clientes" className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">
                  Clientes
                </a>
              </li>
              <li>
                <a href="#contato" className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">
                  Contato
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-sm text-gray-400">
            <div>
              © {currentYear} Gleimatus Empreendimentos. Todos os direitos reservados.
            </div>
          </div>
          
          {/* Legal Disclaimer */}
          <div className="mt-6 pt-6 border-t border-white/10">
            <div className="text-xs text-gray-500 text-center leading-relaxed max-w-4xl mx-auto">
              <p className="mb-2">
                <strong>Aviso Legal:</strong> As imagens e fotos apresentadas neste site são meramente ilustrativas e podem não representar fielmente o produto final. 
                As plantas, projetos, acabamentos e demais especificações técnicas estão sujeitas a alterações sem aviso prévio.
              </p>
              <p>
                Todas as informações contidas neste website, incluindo preços, prazos, características dos empreendimentos e condições comerciais, 
                devem ser obrigatoriamente verificadas e confirmadas junto à Gleimatus Empreendimentos antes de qualquer decisão de compra ou investimento. 
                A empresa não se responsabiliza por eventuais divergências entre as informações aqui apresentadas e as condições reais dos empreendimentos.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}